module.exports = __webpack_public_path__ + "static/media/didYouKnowBulb.36731339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/didYouKnowBulb.jpg
// module id = 91
// module chunks = 0